import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// NewUser page components
import FormField from "components/FormField";
import { useEffect, useState } from "react";
import axios from "axios";
import { URL_API } from "config";
import MDButton from "components/MDButton";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { useAuthContext } from "context/AuthContext";

export default function CooperatedMessagesEighth() {
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState();
  const navigate = useNavigate();

  const { uuid } = useParams();
  const { user } = useAuthContext();

  useEffect(() => {
    (async () => {
      if (user && uuid) await getDescriptions(user.uuid, uuid);
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uuid, user]);

  async function getDescriptions(user_uuid, uuid) {
    const data = await axios.get(
      URL_API + `/description/${user_uuid}/${uuid}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Tag")}`,
        },
      }
    );

    if (!data.data.length && user.profile !== 99) navigate(`/admin/colaboradores/atualizar/${uuid}?step=1`);

    setMessages(data.data);
  }

  async function createDescription(mesg) {
    const body = {
      cooperated_uuid: uuid,
      user_uuid: user?.uuid,
      description: mesg,
      step: 8
    };
    await axios
      .post(URL_API + `/description`, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Tag")}`,
        },
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      })
      .finally(() => {
        getDescriptions(user.uuid, uuid);
      });
  }

  return (
    <>
      <MDBox>
        <MDBox lineHeight={0}>
          <MDTypography variant="h5">Mensagens</MDTypography>
          <MDTypography variant="button" color="text"></MDTypography>
        </MDBox>
        <MDBox mt={1.625}>
          <FormField
            type="text"
            label="Mensagem"
            name="message"
            value={message}
            multiline
            rows={5}
            placeholder="Mensagem"
            onChange={(e) => setMessage(e.target.value)}
          />
        </MDBox>
        <div style={{ marginBottom: "20px", textAlignLast: "right" }}>
          <MDButton
            disabled={!message}
            variant="gradient"
            color="success"
            onClick={() => {
              createDescription(message);
            }}
          >
            adicionar
          </MDButton>
        </div>
        {messages.map((el) => {
          if (el.user_name === "Eu") {
            return (
              <div style={{ marginBottom: "20px" }}>
                <MDBox
                  bgColor="light"
                  color="dark"
                  variant="gradient"
                  borderRadius="lg"
                  shadow="lg"
                  opacity={1}
                  p={2}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "10px",
                    }}
                  >
                    <p style={{ fontFamily: `Arial`, fontSize: "16px", fontWeight: "bold" }}>{el.user_name}</p>
                    <p style={{ fontFamily: `Arial`, fontSize: "13px" }}>
                      {moment(el.created_at).format("hh:mm DD/MM/YYYY")}
                    </p>
                  </div>
                  <p style={{ fontFamily: `Arial`, fontSize: "15px" }}>{el.description}</p>
                </MDBox>
              </div>
            );
          } else {
            return (
              <div style={{ marginBottom: "20px" }}>
                <MDBox
                  variant="gradient"
                  borderRadius="lg"
                  shadow="lg"
                  opacity={1}
                  p={2}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "10px",
                    }}
                  >
                    <p style={{ fontFamily: `Arial`, fontSize: "16px", fontWeight: "bold" }}>{el.user_name}</p>
                    <p style={{ fontFamily: `Arial`, fontSize: "13px" }}>
                      {moment(el.created_at).format("hh:mm DD/MM/YYYY")}
                    </p>
                  </div>
                  <p style={{ fontFamily: `Arial`, fontSize: "15px" }}>{el.description}</p>
                </MDBox>
              </div>
            );
          }
        })}
      </MDBox>
      <MDBox
        mt={2}
        width="100%"
        display="flex"
        justifyContent={user?.profile !== 99 ? "flex-end" : "space-between"}
      >
        {user?.profile === 99 && <MDButton
          variant="gradient"
          color="light"
          onClick={() => navigate(`/admin/colaboradores/atualizar/${uuid}?step=6`)}
        >
          voltar
        </MDButton>}
        <MDButton
          type="submit"
          variant="gradient"
          color="dark"
          onClick={() => user.profile === 99 ? navigate(`/admin/acompanhamento`) : navigate(`/admin/colaboradores/atualizar/${uuid}?step=1`)}
        >
          {user?.profile === 99 ? "salvar" : "próximo"}
        </MDButton>
      </MDBox>
      <ToastContainer />
    </>
  );
}

// typechecking props for CooperatedMessagesEighth
CooperatedMessagesEighth.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};
